namespace('compass.util');

compass.requireLib('compass.util.parse');

compass.util.validationHelper = (function(validator) {
	var _validation_res = [];
	var _validator = validator;
	var _bubble = null;
	var d = jQuery.dom;

	var lib = {};

	lib.attachHints = function()
	{
		// first, let's detach all the hint events
		lib.detachHints();
		
		_validation_res = _validator.validate();
		if(_validation_res.length > 0)
		{
			// focus.hint etc are jQuery namespaced events. Allows us to only bind/unbind a focus event p
			// ertaining to what we're doing here, namely dealing with hints
			// http://docs.jquery.com/Namespaced_Events
			_.each(_validation_res, function (field) {
				field.addClass("invalid")
				.bind('focus.hint', showHint)
				.bind('change.hint', hideHint)
				.bind('blur.hint', hideHint);

				if(field.is("select")){
					field.one('focus', function (event) {
							var temp = _bubble;
							_bubble = null;
							$(this).blur();
							_bubble = temp;
					});
				}
			});
			_validation_res[0].focus();
		}
		return _validation_res.length;
	};

	lib.detachHints = function(){
		// unbind all the events from the dropdown because we run the risk of rebinding over and over every time we hit
		//  the 'cancel reservation' button or whatever the showHint happens to be bound to
		_.each(_validation_res, function(f){
			f.unbind('focus.hint');
			f.unbind('change.hint');
			f.unbind('blur.hint')
			.removeClass("invalid");
		});
	};

	function showHint(){
		var me = $(this);
		if (me.data("valid") === _validator.VALID) {
			return;
		}

		if (me.data("errorIndex") >= 0 && jQuery.isArray(me.data("hint"))) {
			var errorText = me.data("hint")[me.data("errorIndex")];
		}else{
			var errorText = me.data("hint");
		}
		if(_bubble !== null){
			_bubble.remove();
			_bubble = null;
		}
		_bubble = d.div({
			className: "reqHint"
		}, d.div({
			className: "triangle"
		}),
		d.div({
			className: "text"
		}, errorText)
		).insertAfter(me);
		_bubble.css({
			// add the left margin of 'cancelled becasue label' + the left offset of the dropdown + half the width of the dropdown itself
			// this calculation relies on the parent container being positioned.
			"left": (me.outerWidth(true)-_bubble.outerWidth(true))/2 + me.position().left
		});
		if (me.css("float") !== 'none') {
			_bubble.css({
				"margin-top": (me.outerHeight(true))
			});
		}
	}

	function hideHint(){
		if (_bubble !== null) {
			_bubble.remove();
			_bubble = null;
		}
	}

	return lib;
});


/*shared utility functions for dealing with no arrive/depart dates*/
compass.util.restrictedDateHelper = (function() {
	var lib = {};

	/*returns restricted dates. If findrRestrictedArriveDates is true then it will return restricted arrive dates, otherwise restricted depart dates '*/
	lib.restrictedDates = function(nightArray, findrRestrictedArriveDates){
		var key = findrRestrictedArriveDates ? 'noArrive' : 'noDepart';
		/*baseStructure value of true means night structs have structure like, {availBase:{dateRestrictionBase:{}}, nightBase: {}}*/
		/*otherwise night structs have structure like, {restrictions: {}, night: '01/01/01'} */
		/*since backend code still returns two different structures depending on which page we call this funciton from, we need to handle both*/
		var baseStructure = true;
		var restrictedArray = [];
		var filterFunc = function(night){
			return night.availBase.dateRestrictionBase[key]; 	
		};
		var mapFunc = function(night){return night.nightBase.night};
		
		if(nightArray.length){
			if(nightArray[0].restrictions){
				/*we are working with the older, night structure*/
				filterFunc = function(night){
					return night.restrictions[key]; 	
				};
				mapFunc = function(night){return night.date};
			}
		}

		restrictedArray =  _.chain(nightArray)
		.filter(filterFunc)
		.map(mapFunc)
		.value();

		return restrictedArray;
	};

	/*returns an object with an array of violated arrive dates and an array of violated depart dates */
	lib.violatedRestrictedDates = function(stays, noArriveDatesArray, noDepartDatesArray){
		var dateViolations = {violatedArriveDateArray: [], violatedDepartDateArray: []};

		/*unsorted arrive date restrictions*/
		var stayArriveDates = _.chain(stays)
		.map(function(stay){return stay.arrive;})
		.uniq()
		.value();

		/*unsorted depart date restrictions*/
		var stayDepartDates = _.chain(stays)
		.map(function(stay){return stay.depart;})
		.uniq()
		.value();

		/*noArriveDatesArray is sorted, so we loop thorugh it and detect any stays that violate those restrictions*/
		_.each(noArriveDatesArray, function(noArriveDate){
			if(_.contains(stayArriveDates, noArriveDate)){
				dateViolations.violatedArriveDateArray.push(noArriveDate);
			}
		});
		_.each(noDepartDatesArray, function(noDepartDate){
			if(_.contains(stayDepartDates, noDepartDate)){
				dateViolations.violatedDepartDateArray.push(noDepartDate);
			}
		});

		dateViolations.violatedArriveDateArray = _.map(dateViolations.violatedArriveDateArray, function(date){
			return compass.util.parse.ISODateParser(date);
		});
		dateViolations.violatedDepartDateArray = _.map(dateViolations.violatedDepartDateArray, function(date){
			return compass.util.parse.ISODateParser(date);
		});

		return dateViolations;
	};

	/*returns an array of error messages that get generated when a user violates no arrive and no depart restrictions*/
	lib.createDateRestrictionErrors = function(violatedRestrictedDates){
		var monthDateFormat = compass.util.dateFormatter("mmmm dd");
		var errorMessages = [];
		_.each(violatedRestrictedDates.violatedArriveDateArray, function(date){
			var formattedDate = monthDateFormat(date);
			var errorMessage = 'Check-in is not permitted on ' + formattedDate + ' for the room type selected.';
			errorMessages.push(errorMessage);
		});
		_.each(violatedRestrictedDates.violatedDepartDateArray, function(date){
			var formattedDate = monthDateFormat(date);
			var errorMessage = 'Check-out is not permitted on ' + formattedDate + ' for the room type selected.';
			errorMessages.push(errorMessage);
		});
		return errorMessages;
	};

	lib.displayMultiErrorAlert = function(errorMessages) {
		var errorMessageToBeDisplayed = _.reduce(errorMessages, function(curList, curMessage) {
			return (curList + '<br/><br/>' + curMessage);
		});
		jQuery.dom.alert(errorMessageToBeDisplayed);
	};

	return lib;
});